import type {AssetJwtType, AssetJwtItemMapIndex} from '../types';

export const getAssetJwtMapIndex = (
	assetId: number,
	type?: AssetJwtType,
): AssetJwtItemMapIndex => {
	return `${assetId}-${type ?? 'proxy'}`;
};
